var map = {
	"./animal.svg": 521,
	"./arrow.svg": 522,
	"./bicycle.svg": 523,
	"./boat.svg": 524,
	"./bus.svg": 525,
	"./car.svg": 526,
	"./colheitadeira.svg": 527,
	"./colheitadeira2.svg": 528,
	"./crane.svg": 529,
	"./default.svg": 530,
	"./helicopter.svg": 531,
	"./motorcycle.svg": 532,
	"./offroad.svg": 533,
	"./person.svg": 534,
	"./pickup.svg": 535,
	"./plane.svg": 536,
	"./polinizador.svg": 537,
	"./pulverizador.svg": 538,
	"./pulverizador2.svg": 539,
	"./ship.svg": 540,
	"./tractor.svg": 272,
	"./train.svg": 541,
	"./tram.svg": 542,
	"./trolleybus.svg": 543,
	"./truck.svg": 544,
	"./truck9.svg": 545,
	"./truck9b.svg": 546,
	"./van.svg": 547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 664;